module.exports = __webpack_public_path__ + "img/nyandarua.4c2dcc14.png";